import Collaborator from './Collaborator';

export default Collaborator;
